<main class="welcome-planner-view__main">
  <ul class="welcome-planner-view__items">
    <li class="welcome-planner-view__item">
      <ci-icon 
        class="welcome-planner-view__icon"
        type="svg" 
        name="navigation" 
        scale="1.5x"
      ></ci-icon>
      <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
        <strong>{{ 'Empieza tu viaje' | translate }}</strong>
        {{ 'con el botón “Comenzar Ruta”' | translate }}
      </p>
    </li>
    
    <li class="welcome-planner-view__item">
      <ci-icon 
        class="welcome-planner-view__icon"
        type="svg" 
        name="type" 
        scale="1.5x"
      ></ci-icon>
      <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
        <strong>{{ 'Personaliza tu día' | translate }}</strong>
        {{ 'editando los recursos pulsando en el botón “Editar Ruta”' | translate }}
      </p>
    </li>
    
    <li class="welcome-planner-view__item">
      <ci-icon 
        class="welcome-planner-view__icon"
        type="svg" 
        name="ticket" 
        scale="1.5x"
      ></ci-icon>
      <p class="welcome-planner-view__item-text ci-paragraph-p1-regular">
        <strong>{{ 'Muévete sin complicaciones' | translate }}</strong> 
        {{ 'adquiriendo un abono transporte postpago de' | translate }} <strong> MPass </strong>
        {{ 'para usar el transporte público' | translate }}
      </p>
    </li>
  </ul>
</main>